import VacancyArchiveConfirmationModal from './VacancyArchiveConfirmationModal.component';

export default VacancyArchiveConfirmationModal;
